import type { Selector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';
import type { MatchFilterValues, SportsMatchFilteringState } from './types';

export const selectors = withEventBasedMarketTemplateModelSelectors(
  defaultState,
  (slice, createSelector) => ({
    firstLoadComplete: () => slice((state) => state.firstLoadComplete),
    hasPreloaded: () => slice((state) => state.hasPreloaded),
    errorCode: () => slice((state) => state.errorCode),
    filters: () => slice((state) => state.filters),
    filtersOptions(this: { filters: Selector<RootState, SportsMatchFilteringState['filters']> }) {
      return createSelector(this.filters, (filters) => ({
        durations: filters.durations,
        marketTypes: filters.marketTypes
      }));
    },
    filterSearchParams() {
      return createSelector(
        (rootState: RootState) => select.location.getQuery(rootState),
        ({ market, duration }): MatchFilterValues => ({ market, duration })
      );
    },
    filterValues(this: {
      filters: Selector<RootState, SportsMatchFilteringState['filters']>;
      filterSearchParams: Selector<RootState, MatchFilterValues>;
    }) {
      return createSelector(
        this.filters,
        this.filterSearchParams,
        (filters, searchParams): MatchFilterValues => ({
          duration: searchParams.duration ?? filters.durations.find(({ selected }) => selected)?.id,
          market: searchParams.market ?? filters.marketTypes.find(({ selected }) => selected)?.id
        })
      );
    },
    templateGroups: () => slice((state) => state.templateGroups),
    showLoadingIndicator: () =>
      slice(
        ({ firstLoadComplete, loading, polling }) =>
          (!firstLoadComplete && loading) || (!polling && firstLoadComplete && loading)
      )
  })
);
